/* eslint-disable import/extensions */
/* eslint-disable max-lines-per-function */
/* eslint-disable import/prefer-default-export */

import Swiper from "swiper";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import "swiper/css";
import "./slider.scss";

const SLIDER_SPEED = 10000;
const MOMENTUM_RATIO = 1;

export function initSlider({
  containerSelector,
  spaceBetween,
  loop = true,
  speed = SLIDER_SPEED,
  autoplay = {
    delay: 0,
    disableOnInteraction: false
  }
}) {
  const $container = document.querySelector(containerSelector);

  if (!$container) {
    return;
  }

  let mouseIn = false;

  const swiper = new Swiper($container, {
    modules: [Autoplay, FreeMode, Navigation],
    loop,
    speed,
    centeredSlides: false,
    slidesPerView: "auto",
    loopPreventsSliding: false,
    autoplay,
    spaceBetween,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumBounce: false,
      momentumRatio: MOMENTUM_RATIO
    },
    navigation: {
      prevEl: `${containerSelector} .js-jiffytransfers-landing-v2-ui-slider-button-prev`,
      nextEl: `${containerSelector} .js-jiffytransfers-landing-v2-ui-slider-button-next`,
      addIcons: false
    },
    on: {
      navigationPrev: () => {
        swiper.slidePrev(500);
      },
      navigationNext: () => {
        swiper.slideNext(500);
      },
      touchEnd: () => {
        setTimeout(
          () => {
            if (!mouseIn) {
              swiper.autoplay.start();
            }
          },
          MOMENTUM_RATIO * 1000 * 2
        );
      }
    }
  });

  if (autoplay) {
    $container.addEventListener("mouseenter", () => {
      mouseIn = true;
      swiper.autoplay.stop();
      swiper.setTranslate(swiper.getTranslate());
    });

    $container.addEventListener("mouseleave", () => {
      mouseIn = false;

      setTimeout(() => {
        if (!mouseIn) {
          swiper.update();
          swiper.autoplay.start();
        }
      }, 100); // Small delay to prevent race conditions
    });
  }
}
